module.exports = __webpack_public_path__ + "static/img/cixiu2.9e7f8e46.png";